module.exports = __webpack_public_path__ + "img/card-image-6.b26faf1e.jpg";